/*
  Погашение отложено - решение человека по загрузке под сомнением сторожа.

  Решение владельца 19.10.2026: сторож объёма больше ничего не останавливает,
  загрузка записывается целиком. Опасно только погашение месяцев, которых в
  выгрузке нет: обрезанная выгрузка обнулила бы долги молча. Поэтому, когда она в
  разы меньше прошлой, такие месяцы не гасятся, а ждут ответа здесь - «Погасить»
  (выгрузка полная) или «Оставить как есть» (неполная).

  Блок один на два места - итог загрузки 1С и строку журнала: решение одно, и
  две его редакции разошлись бы на первой правке.
*/

import { useState } from 'react'

import { api } from '../api/client.js'
import { plural } from '../api/format.js'
import { Notice } from './Common.jsx'

const months = (count) => plural(count, 'месяц', 'месяца', 'месяцев')

function decidedText(settle, result) {
  if (!settle) return 'Оставлено как есть: долг по этим месяцам сохранён.'
  const skipped = result.skipped
    ? ` Не погашено ${months(result.skipped)}: после этой загрузки их переписала другая.`
    : ''
  return `Погашено ${months(result.settled)}.${skipped}`
}

/*
  `onBusy` - окно вокруг узнаёт, что решение в пути (ревью 30.10.2026, аудит 5.3 «Окна»):
  Esc или нажатие мимо закрывали окно посреди запроса, и отказ показать было негде.
*/
export default function DeferredSettlement({ runId, doubt, count, onDecided, onBusy }) {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)
  const [done, setDone] = useState(null)

  async function decide(settle) {
    setBusy(true)
    onBusy?.(true)
    setError(null)
    try {
      const result = await api.decideDeferred(runId, settle)
      setDone(decidedText(settle, result))
      onDecided?.()
    } catch (failure) {
      setError(failure)
    } finally {
      setBusy(false)
      onBusy?.(false)
    }
  }

  if (done) return <Notice kind="ok">{done}</Notice>
  return (
    <div className="notice notice--warn" role="status">
      <div className="notice__what">
        Погашение отложено: {months(count)} ждут вашего решения.
      </div>
      {doubt ? <div className="notice__do">{doubt}</div> : null}
      <div className="notice__do">
        Ничего не потеряно: всё, что есть в выгрузке, уже записано. Решение касается только
        месяцев, которых в ней нет. Если выгрузка полная - погасите их; если неполная - оставьте
        долг как есть.
      </div>
      <div className="row row--tight">
        <button type="button" className="button" disabled={busy} onClick={() => decide(true)}>
          Погасить
        </button>
        <button
          type="button"
          className="button button--quiet"
          disabled={busy}
          onClick={() => decide(false)}
        >
          Оставить как есть
        </button>
      </div>
      <Notice error={error} />
    </div>
  )
}
